import { z } from 'zod'
import { createdAtSearchShape, createdAtSortSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

const id = z.coerce.number().int().positive().optional().catch(undefined)
export const expenseSearchSchema = z.object({
  current: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  id,
  keyword: z.string().trim().max(255).optional().catch(undefined),
  organizationId: id,
  payeeId: id,
  expenseBusinessId: id,
  dueFrom: z.iso.date().optional().catch(undefined),
  dueTo: z.iso.date().optional().catch(undefined),
  ...createdAtSearchShape,
  ...createdAtSortSearchShape,
  ...creatorMemberSearchShape
})
export type ExpenseSearch = z.infer<typeof expenseSearchSchema>
